import './EmptyState.scss';
import cn from 'classnames';
import { ReactNode } from 'react';
import EmptyIllustration from './empty.svg?react';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  subtitle?: string;
  // Prose alternative to title/subtitle for callers whose message is body copy rather than a
  // heading (e.g. a widget-level empty state that already has its own header elsewhere).
  description?: string;
  className?: string;
  children?: ReactNode;
}

export const EmptyState = ({
  icon = <EmptyIllustration />,
  title,
  subtitle,
  description,
  className,
  children
}: EmptyStateProps) => (
  <div className={cn('empty-state', className)}>
    <div className='empty-state-icon'>{icon}</div>
    {title && <h1 className='empty-state-title'>{title}</h1>}
    {subtitle && <h2 className='empty-state-subtitle'>{subtitle}</h2>}
    {description && <p className='empty-state-description'>{description}</p>}
    {children && <div className='empty-state-actions'>{children}</div>}
  </div>
);
